import React, { useEffect, useState, useContext } from "react";
import { useParams, useHistory } from "react-router";
import axios from "axios";
import { AuthContext } from "../helpers/AuthContext";
//import { PostContext } from "../helpers/PostContext";

function Post() {
  let { id } = useParams();
  const [postObject, setPostObject] = useState({});
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const { authState } = useContext(AuthContext);

  let history = useHistory();

  useEffect(() => {
    // const controller = new AbortController();

    // const fetchUsers = async () => {
    //   try {
    //   const resbasic = await axios.get("http://localhost:3000/posts/byId/"+String(id),
    //   {signal : controller.signal});
    //   setPostObject(resbasic.data);
    //   const resuser = await axios.get("http://localhost:3000/comments/"+String(id),
    //   {signal : controller.signal});
    //   setComments(resuser.data);
    //   } catch(err) { 
    //     if (axios.isCancel(err)) return;
    //     console.log(err);
    //   }
    // };
    // fetchUsers();
    // return () => controller.abort();

    
    axios.get("https://api.inloop.live/posts/byId/"+String(id)).then((response) => { //not works on its own
      setPostObject(response.data);
    });
    // setPostObject(PostContext);

    axios.get("https://api.inloop.live/comments/"+String(id)).then((response) => { //works on its own
      setComments(response.data);
    });
    // axios.all([
    //   axios.get("http://localhost:3000/posts/byId/"+String(id)),
    //   axios.get("http://localhost:3000/comments/"+String(id))
    // ]).then(axios.spread((post,comment)=>{
    //   setPostObject(post.data);
    //   setComments(comment.data);
    // }));
  }, [id]);
  

  const addComment = () => {
    axios
      .post(
        "https://api.inloop.live/comments",
        {
          commentBody: newComment,
          PostId: id,
        },
        {
          headers: {
            accessToken: localStorage.getItem("accessToken"),
          },
        }
      )
      .then((response) => {
        if (response.data.error) {
          console.log(response.data.error);
        } else {
          const commentToAdd = {
            commentBody: newComment,
            username: response.data.username,
          };
          setComments([...comments, commentToAdd]);
          setNewComment("");
        }
      });
  };

  const deleteComment = (id) => {
    axios
      .delete("https://api.inloop.live/comments/"+String(id), {
        headers: { accessToken: localStorage.getItem("accessToken") },
      })
      .then(() => {
        setComments(
          comments.filter((val) => {
            return val.id !== id;
          })
        );
      });
  };

  const deletePost = (id) => {
    axios
      .delete("https://api.inloop.live/posts/"+String(id), {
        headers: { accessToken: localStorage.getItem("accessToken") },
      })
      .then(() => {
        history.push("/");
      });
  };

  const editPost = (option) => {
    if (option === "title") {
      let newTitle = prompt("Enter New Title:");
      axios.put(
        "https://api.inloop.live/posts/title",
        {
          newTitle: newTitle,
          id: id,
        },
        {
          headers: { accessToken: localStorage.getItem("accessToken") },
        }
      );

      setPostObject({ ...postObject, title: newTitle });
    } else {
      let newPostText = prompt("Enter New Text:");
      axios.put(
        "https://api.inloop.live/posts/postText",
        {
          newText: newPostText,
          id: id,
        },
        {
          headers: { accessToken: localStorage.getItem("accessToken") },
        }
      );

      setPostObject({ ...postObject, postText: newPostText });
    }
  };

  return (
    <div className="postPage">
      <h2>Post Page</h2>
      <div className="leftSide">
        <div className="post" id="individual">
          <div
            className="title"
            onClick={() => {
              if (authState.username === postObject.username) {
                editPost("title");
              }
            }}
          >
            {postObject.title}
          </div>
          <div
            className="body"
            onClick={() => {
              if (authState.username === postObject.username) {
                editPost("body");
              }
            }}
          >
            {postObject.postText}
          </div>
          <div className="footer">
            {postObject.username}
            {authState.username === postObject.username && (
              <button
                onClick={() => {
                  deletePost(postObject.id);
                }}
              >
                {" "}
                Delete Post
              </button>
            )}
          </div>
        </div>
      </div>
      <div className="rightSide">
        <div className="addCommentContainer">
          <input
            type="text"
            placeholder="Comment..."
            autoComplete="off"
            id="inputComments"
            value={newComment}
            onChange={(event) => {
              setNewComment(event.target.value);
            }}
          />
          <button onClick={addComment}> Add Comment</button>
        </div>
        <div className="listOfComments">
          {comments.map((comment, key) => {
            return (
              <div key={key} className="comment">
                {comment.commentBody}
                <label> Username: {comment.username}</label>
                {authState.username === comment.username && (
                  <button
                    onClick={() => {
                      deleteComment(comment.id);
                    }}
                  >
                    X
                  </button>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default Post;
